<div class="container">
  <div class="flex" *ngIf="!loading && !login">
    <div id="instructions">
      <div>
        <iframe width="1000" height="500" src="https://www.youtube.com/embed/lVZqz4omXnQ" title="YouTube video player"
          frameborder="0" class="responsive-iframe"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
      <div style="padding-top: 6%;">
        <iframe width="1000" height="500" src="https://www.youtube.com/embed/sS2EhExwtFE" title="YouTube video player"
          frameborder="0" class="iframe-responsive"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && login">

  <div class="main-container">
    <div class="tb-lft-content">
      <div class="list-wrapper"> 
        <div class="list">
          <ul class="title">

            <li [class.active]="activeSection === 'choice-of-access-plans'" (click)="scrollTo('choice-of-access-plans')">
                1. Choice of Access Plans
            </li>
            <li [class.active]="activeSection === 'login-with-user-credentials'" (click)="scrollTo('login-with-user-credentials')">
                2. Login with user credentials
            </li>

            <li [class.active]="activeSection === 'profile-and-adding-balance'" (click)="scrollTo('profile-and-adding-balance')">
                3. Profile and Adding Balance
            </li>
            <li [class.active]="activeSection === 'preview'" (click)="scrollTo('preview')">
                4. Preview 
            </li>
            <li [class.active]="activeSection === 'tasks'" (click)="scrollTo('tasks')">
                5. Tasks 
            </li>
            
            <li>
              <div class="sub" [class.active]="activeSection === 'creating-task'" (click)="scrollTo('creating-task')">
                6. Creating a Task
              </div>

              <ul class="sub-list">

                <li>
                  <div class="sub" [class.active]="activeSection === 'value-added-data-products'" (click)="scrollTo('value-added-data-products')">
                    6.1. Value Added Data Products
                  </div>

                  <ul class="sub-list">
                    <li [class.active]="activeSection === 'super-resolution'" (click)="scrollTo('super-resolution')">
                      6.1.1. Super Resolution
                    </li>

                    <li [class.active]="activeSection === 'digital-model'" (click)="scrollTo('digital-model')">
                      6.1.2. Digital model
                    </li>
                    <li [class.active]="activeSection === 'indices'" (click)="scrollTo('indices')">
                      6.1.3. Indices 
                    </li>
                  </ul>

                </li>

              </ul>
            </li>
            <li [class.active]="activeSection === 'task-progress'" (click)="scrollTo('task-progress')">
                7. Task Progress 
            </li>

            <li [class.active]="activeSection === 'cart-process'" (click)="scrollTo('cart-process')">
                8. Cart process 
            </li>
            <li [class.active]="activeSection === 'payment'" (click)="scrollTo('payment')">
                9. Payment  
            </li>
            <li [class.active]="activeSection === 'orders'" (click)="scrollTo('orders')">
                10. Orders   
            </li>
            <li [class.active]="activeSection === 'collections'" (click)="scrollTo('collections')">
                11. Collections    
            </li>
            <li [class.active]="activeSection === 'deposits'" (click)="scrollTo('deposits')">
                12. Deposits    
            </li>
            <li [class.active]="activeSection === 'budgets'" (click)="scrollTo('budgets')">
                13. Budgets    
            </li>
            <li [class.active]="activeSection === 'quotes'" (click)="scrollTo('quotes')">
                14. Quotes    
            </li>
            <li [class.active]="activeSection === 'users'" (click)="scrollTo('users')">
                15. Users    
            </li>
            <li [class.active]="activeSection === 'sub-accounts'" (click)="scrollTo('sub-accounts')">
                16. Sub Accounts   
            </li>
            <li [class.active]="activeSection === 'additional-information'" (click)="scrollTo('additional-information')">
                17. Additional Information   
            </li>
            <li [class.active]="activeSection === 'acronyms'" (click)="scrollTo('acronyms')">
                18. Acronyms    
            </li>
            <li [class.active]="activeSection === 'glossary'" (click)="scrollTo('glossary')">
                  19. Glossary    
              </li>
            <li [class.active]="activeSection === 'conclusion'" (click)="scrollTo('conclusion')">
                20. Conclusion     
            </li>
            

          </ul>
        </div>
      </div>
    </div>
    <div class="tb-rgt-content">
      <div class="container">
          <h3>Introduction</h3>
          <!-- <div class="header">
              <h2>Introduction</h2>
          </div> -->
          <p>
            This user guide explains how to use the <span class="spl-char">EARTHEYE</span> situational awareness platform. This is a living document and is updated regularly.
          </p>

          <section class="sub-container" id="choice-of-access-plans">
            <h3>1. Choice of Access Plans</h3>
            <p>
              Access to the EARTHEYE platform is now offered through simplified deposit plans, with four new options introduced: Starter, Standard, Premium, and Custom <i>(Refer Figure - 1)</i>. The Custom plan requires users to contact sales via the website or platform to access discounts; the other plans list all specifications and details. These new plans give users greater flexibility to choose the option that best fits their usage patterns, sensor requirements, and required platform capabilities. During registration, users can select one of the four plans and request a plan upgrade at any time from the profile page.
            </p>
            <div class="attachement-img">
              <img src="../../../../../assets/how-it-works/image1.png" alt="">
              <p class="text-centre"><i>Figure - 1</i></p>
            </div>
            
          </section>

          <section class="sub-container" id="login-with-user-credentials">
            <h3>2. Log in with user credentials</h3>
            <p>
              A registered user can sign in using their credentials. A new user must register using the <span class="spl-bold">‘Sign Up’</span> option (Refer Figure - 2).
            </p>
            <div class="attachement-img">
              <img src="../../../../../assets/how-it-works/image2.png" alt="">
              <p class="text-centre"><i>Figure - 2</i></p>
            </div>
            
            <p>
              Each time a registered user logs in, the platform sends a token to their registered email for authentication. Once signed in, the platform directs the user to the dashboard screen.
            </p>
            
          </section>
          <section class="sub-container" id="profile-and-adding-balance">
            <h3 >3. Profile and Adding Balance</h3>
          
            <p>
              Users can view and edit their user profile information on this page. Click on the yellow highlighted text or the username at the top right of the screen (Refer Figure - 3). 
            </p>
            <div class="attachement-img">
              <img src="../../../../../assets/how-it-works/image3.png" alt="">
              <p class="text-centre"><i>Figure - 3</i></p>
            </div>

            <section class="sub-content">
              <h4 >Users can perform the following activities :</h4>
              <ul>
                  <li>Change their password and address.</li>
                  <li>Update or change their profile photo from this page.</li>
                  <li>Deposit money to their account by clicking on the <span class="spl-bold">‘Add Balance’</span>, entering the amount, currency type, selecting the payment method and clicking <span class="spl-bold">‘Deposit’ </span> <i>(Refer Figure - 4)</i>.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image4.png" alt="">
                      <p class="text-centre"><i>Figure - 4</i></p>
                    </div>
                  </li>
                  <li>Click on the <span class="spl-bold">‘Platform Settings’</span> drop-down to access budget and     permissions options <i>(Refer Figure - 5)</i>.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image5.png" alt="">
                      <p class="text-centre"><i>Figure - 5</i></p>
                    </div>
                  </li>
                  
                  <li>In <span class="spl-bold">‘Platform Settings’</span>, you can enable user-level budget allocation (sub-budget allocation) <i>(Refer Figure - 6)</i>. This allows the superuser to assign budgets to users while ensuring usage remains within the assigned limits. The superuser can manage this allocation by selecting each user and setting their budgets in the <span class="spl-bold">‘Users’</span> screen, as shown in Section 14.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image6.png" alt="">
                      <p class="text-centre"><i>Figure - 6</i></p>
                    </div>
                  </li>
                  <li>
                    The superuser automatically has full access and can assign other users one or more permissions <i>(Refer Figure - 7)</i>. Users with no assigned permissions can perform all tasks. As tasks progress through the workflow, the platform notifies users with relevant permissions to take action. If the next stage has no assigned users, the platform will notify the superuser by default. Section 14 shows the permission settings on the <span class="spl-bold">‘Users’</span> screen.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image7.png" alt="">
                      <p class="text-centre"><i>Figure - 7</i></p>
                    </div>
                  </li>
                  <li>
                    Set their target data delivery <span class="spl-bold">‘Storage Type’</span> from Profile Settings. The storage types are Amazon S3, Azure Blob and Secure FTP. Select the storage type, input keys and other information and click <span class="spl-bold">‘Save Changes’</span>. The platform verifies the keyed details in less than a minute before you can proceed <i>(Refer Figure - 8a and 8b)</i>.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image8a.png" alt="">
                      <p class="text-centre"><i>Figure - 8a</i></p>
                    </div>
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image8b.png" alt="">
                      <p class="text-centre"><i>Figure - 8b</i></p>
                    </div>
                  </li>
                  <li>Here, users can also switch between dark and light themes (Refer Figure - 9).
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image9.png" alt="">
                      <p class="text-centre"><i>Figure - 9</i></p>
                    </div>
                  </li>
              </ul>
            </section>
          </section>

          <section class="sub-container" id="preview">
            <h3 >4. Preview</h3>
            <p>
              The platform's preview section lists details of <span class="spl-bold">‘Sensors’</span> and <span class="spl-bold">‘Feeds’</span> on the EARTHEYE platform, 
              helping users to review the available options.
            </p>
            <p>The numbered arrows in Figure 10 are explained below:</p>
            
            <ol>
              <li>
                Users can preview the list of sensors on the platform by clicking on the <span class="spl-bold">‘Sensors Preview’</span> tab.
              </li>
              <li>
                Users can preview the list of available feeds on the platform by clicking on the <span class="spl-bold">‘Feeds Preview’</span> tab.
              </li>
              <li>
                <span class="spl-bold">‘Night Imagery’</span> toggle when enabled, displays the available sensors with night-imaging capability.</li>
              <li>
                <span class="spl-bold">‘Daily/Sub-daily Revisit’</span> toggle allows users to review the sensors that have the functionality of daily/sub-daily revisit frequencies.
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘Show Upcoming Sensors’</span> toggle, users can view the upcoming sensors on the platform and plan their tasks/projects accordingly.
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘i’ icon</span>, users can see cancellation timelines and their respective charges for the sensor.
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘Location’ icon</span>, users can select their POI or AOI.
              </li>
              <li>
                The <span class="spl-bold">‘Frequency’ icon</span> gives information on the type of band for that particular sensor.
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘Image’ icon</span>, users can check sample images for the sensor.
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘Satellite’ icon</span>, users can view the Two-line Element Set (TLE) positions of the selected satellite(s).
              </li>
              <li>
                By clicking on the <span class="spl-bold">‘handshake’ icon</span>, users can review the End-user license agreement (EULA).
              </li>
              <li>
                The <span class="spl-bold">‘Mask’ icon</span> represents that the sensor is obfuscated.
              </li>
              <li>
                The <span class="spl-bold">‘Globe-satellite-orbit’ icon</span> represents that opportunity tasking is available for the sensor.
              </li>
              <li>
                <span class="spl-bold">Opportunity tasking sensors</span> toggle displays all sensors with opportunity tasking available.
              </li>
              <li>
                <span class="spl-bold">Obfuscated sensors</span> toggle displays sensors that do not require customer information.
              </li>
            </ol>
            <div class="attachement-img">
              <img src="../../../../../assets/how-it-works/image10.png" alt="">
              <p class="text-centre"><i>Figure - 10</i></p>
            </div>
          </section>
          
          <section class="sub-container" id="tasks">
            <h3 >5. Tasks</h3>
            <p>This is the <span class="spl-bold">Tasks</span> page, which lists all user tasks in one place <i>(Refer Figure - 11)</i>.</p>
            <div class="attachement-img">
              <img src="../../../../../assets/how-it-works/image11.png" alt="">
              <p class="text-centre"><i>Figure - 11</i></p>
            </div>

            <section class="sub-content">
              <ul>
                <li>
                  Users can <span class="spl-bold">search by projects or tasks</span> using the search bar and filter them, or list by <span class="spl-bold">Recent, Completed, Inactive,</span> or <span class="spl-bold">All</span> <i>   (Refer Figure - 12)</i>.
                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image12.png" alt="">
                      <p class="text-centre"><i>Figure - 12</i></p>
                    </div>
                </li>
                <li>
                  Each task row shows key details, including <span class="spl-bold">Project Name, Task Name, submission/start/end dates (UTC), order cost, frequency, feeds </span> and <span class="spl-bold">status</span>.
                </li>
                <li>
                  The platform operates in UTC, while users enter their Time of Interest (TOI) in their local 
                  (registered country) time when creating a task. To prevent confusion and cater to different preferences, the dashboard allows users to select whether to display task times in UTC or their local time, according to their settings <i>(Refer Figure - 13)</i>.
                  <div class="attachement-img">
                    <img src="../../../../../assets/how-it-works/image13.png" alt="">
                    <p class="text-centre"><i>Figure - 13</i></p>
                  </div>
                </li>
                <li>
                  Expanding tasks lets you view sensor-level details, including Sensor Name, Resolution, Tasked Area, Cloud Cover, Capture Times, and Sensor Cost.
                </li>
                <li>
                  The <span class="spl-bold">status indicators</span> (green/amber/red) show the task&#39;s current state.
                </li>
                <li>
                  Users can <span class="spl-bold">preview tasks,</span> access <span class="spl-bold">additional actions</span> (three-dot menu), or manage sensors using options like <span class="spl-bold">‘Cancel Sensor’, ‘Add to Cart’,</span> or <span class="spl-bold">‘Proceed to Pay’</span>.
                </li>
                <li>
                  Users can add feeds to their order by clicking the blue <span class="spl-bold">‘Earth-satellite’</span> icon as shown in Figure 14 because the satellite operator <span class="spl-bold">‘Approved’</span> the task. If the icon is grey, the task is yet to be approved or has been <span class="spl-bold">‘Rejected’</span> or <span class="spl-bold">‘Failed’</span> and users cannot attach any feeds.
                  <div class="attachement-img">
                    <img src="../../../../../assets/how-it-works/image14.png" alt="">
                    <p class="text-centre"><i>Figure - 14</i></p>
                  </div>
                </li>
                <li>
                  To see the reason for a task being rejected or failed, users can click on the ‘i’ icon next to the status <i>(Refer Figure - 15)</i>.
                  <div class="attachement-img">
                    <img class="half-width" src="../../../../../assets/how-it-works/image15.png" alt="">
                    <p class="text-centre"><i>Figure - 15</i></p>
                  </div>
                </li>
                <li>
                  <span class="spl-bold">Feedback and improvements:</span> Users can provide feedback on improvements and requirements by clicking on the icon next to the username on the dashboard page <i>(Refer Figure - 16)</i>.
                  <div class="attachement-img">
                    <img src="../../../../../assets/how-it-works/image16.png" alt="">
                    <p class="text-centre"><i>Figure - 16</i></p>
                  </div>
                </li>
              </ul>
            </section>
            
          </section>

          <section class="sub-container" id="creating-task">
              <h3 >6. Creating a Task</h3>
              <p>
                There are no tasks listed on the dashboard when a user first arrives here. When a user creates tasks, theplatform will list the tasks with all the task details as shown in Figure 16. The <span class="spl-bold">‘New’</span> button in the top-right corner creates a new task directly from the dashboard <i>(Refer Figure - 17)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image17.png" alt="">
                <p class="text-centre"><i>Figure - 17</i></p>
              </div>

              <p>
                By clicking on the <span class="spl-bold">‘Click Here’</span> link, all Sensor details pop up <i>(Refer Figure - 18a and 18b)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image18a.png" alt="">
                <p class="text-centre"><i>Figure - 18a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image18b.png" alt="">
                <p class="text-centre"><i>Figure - 18b</i></p>
              </div>

              <p>
                Users will choose a <span class="spl-bold">‘Task Strategy’</span> from the list <i>(Refer Figure - 19)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image19.png" alt="">
                <p class="text-centre"><i>Figure - 19</i></p>
              </div>

              <h4>Tasking Strategy 1: User-Initiated</h4>
              <p>
                <span class="spl-bold">Flow 1:</span> Automated tasking <br>
                This is the basic tasking flow when the user selects ‘user-initiated’. The automated tasking allows users to submit a location of interest and a time of interest, and leave it to the chosen satellite operator(s) to collect the data optimally within the selected tasking tier. Users can choose one or more sensors for tasking requests using the automated tasking button.
              </p>
              <p>
                <span class="spl-bold">Flow 2:</span> Opportunity tasking <br> 
                This optional workflow lets the user select from a list of feasibility options. Feasibility-based tasking allows users to choose a specific time within a specified date range to order a task. Users can request it using the opportunity-tasking button. The selected satellite operator will provide the list of feasibility dates and times, and will be available on the dashboard for the specified task, along with the sensor.
              </p>

              <h4>Tasking Strategy 2: Outcome-based tasking</h4>
              <p>
                Users set up the project requirements, like user-initiated ones. If the user chooses outcome-based, then the platform will not show the sensor-cost screen. Instead, users enter the required sensor, resolution, acceptable cloud cover (if optical), required lead time, and budget. The platform then selects the sensor(s) and presents them to the user for placing the order on the dashboard.
              </p>

              <h4>Tasking Strategy 3: Help Select Sensor(s)</h4>
              <p>
                This tasking strategy helps identify sensors for the users’ use cases. This tasking strategy filters sensors according to the use case. The platform will filter and display the sensors in the sensor-cost section, based on the selection.
              </p>

              <h4>Tasking Strategy 4: Tip and Cue</h4>
              <p>
                <span class="spl-bold">Flow 1:</span> Tip and Cue with observation <br> 
                In the tip-and-cue workflow, one sensor (the tipped sensor) detects an event of interest, and another sensor (the cued sensor) then examines the details. Like all workflows, this workflow operates within the context of an area of interest (AOI) or point of interest (POI) and a TOI. Only specific date and period tasking is possible with tip-and-cue.
              </p>
              <p>
                <span class="spl-bold">Flow 2:</span> Tip and Cue with rule-based <br> 
                In this workflow, a predefined rule replaces the observation element, for example, ‘if cloud cover &gt; 20%’. The rules are predefined, and users can choose one or more‌ sensors from the list for tip-and-cue or combined taskings. As before, the platform allows only specific dates and period TOIs.
              </p>

              <h4>Tasking Strategy 5: TLE-Based Tasking</h4>
              <p>
                In this workflow, the platform displays satellite positions. Users can select a future point on any satellite path and complete the remaining tasking workflow details, as with other tasks. The platform will apply the cost details of the chosen sensor.
              </p>

              <h4>Tasking Strategy 6: AIS Included</h4>
              <p>
                In this tasking strategy, users must pair the AIS sensor with another sensor on the platform. The platform supports only automated tasking with AOI and period frequency for submission.
              </p>
              <p>
                Users create a <span class="spl-bold">‘Project Name’</span> with the related tasks <i>(Refer Figure - 20)</i>.
              </p>
              <div class="attachement-img">
                <img class="half-width" src="../../../../../assets/how-it-works/image20.png" alt="">
                <p class="text-centre"><i>Figure - 20</i></p>
              </div>

              <p>
                Users create a <span class="spl-bold">‘Task Name’</span> <i>(Refer Figure - 21)</i>.
              </p>
              <div class="attachement-img">
                <img class="half-width" src="../../../../../assets/how-it-works/image21.png" alt="">
                <p class="text-centre"><i>Figure - 21</i></p>
              </div>

              <p>
                Users select an <span class="spl-bold">‘Intent’</span> <i>(Refer Figure - 22)</i>.
              </p>
              <div class="attachement-img">
                <img class="half-width" src="../../../../../assets/how-it-works/image22.png" alt="">
                <p class="text-centre"><i>Figure - 22</i></p>
              </div>

              <p>
                Users select their <span class="spl-bold">‘Purpose’</span> <i>(Refer Figure - 23)</i>.
              </p>
              <div class="attachement-img">
                <img class="half-width" src="../../../../../assets/how-it-works/image23.png" alt="">
                <p class="text-centre"><i>Figure - 23</i></p>
              </div>

              <p>
                A target can be a POI or an AOI. Click on any of the options on the right side of the window. If users select a ‘rectangle’, for example, they will draw a rectangle on the map, which automatically captures coordinates in the <span class="spl-bold">‘Select Target’</span> field <i>(Refer Figure - 24)</i>. Users can also create an AOI directly from the map search by entering a closed polygon instead of drawing it manually. This feature allows users to enter coordinate pairs to define the AOI, improving precision. To use this functionality, users enter longitude and latitude pairs, separated by a semicolon, in the map search bar; the search bar then auto-generates the AOI for the tasking request.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image24.png" alt="">
                <p class="text-centre"><i>Figure - 24</i></p>
              </div>

              <p>
                As highlighted in Figure 25, the &#39;Base Map&#39; icon allows users to select from a variety of map types - Bing Maps Aerial, Sentinel-2, Bing Maps Road, Blue Marble and OpenStreetMap.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image25.png" alt="">
                <p class="text-centre"><i>Figure - 25</i></p>
              </div>

              <p>
                The <span class="spl-bold">‘Home’</span> icon in Figure 26 allows a user to return to the selected point or area after choosing a target on the map.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image26.png" alt="">
                <p class="text-centre"><i>Figure - 26</i></p>
              </div>

              <p>
                Users then specify the <span class="spl-bold">‘Frequency’</span> and a <span class="spl-bold">‘Date Range’</span> for the selected target <i>(Refer Figure - 27)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image27.png" alt="">
                <p class="text-centre"><i>Figure - 27</i></p>
              </div>

              <p>
                Once the user has entered the required details, the platform will display the requested TOI's cloud cover.
              </p>
              <p>
                <span class="spl-bold">Cloud cover:</span> Displays cloud-cover details. Cloud cover details are available on a daily and hourly basis <i> (Refer Figure - 28)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image28.png" alt="">
                <p class="text-centre"><i>Figure - 28</i></p>
              </div>

              <p>
                After completing all mandatory fields in the <span class="spl-bold">‘Tasking Details’</span> section, the platform enables the <span class="spl-bold">‘Sensor-Cost Details’</span> section <i> (Refer Figure - 29)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image29.png" alt="">
                <p class="text-centre"><i>Figure - 29</i></p>
              </div>

              <p>
                Figure 30 explains how users can choose sensor(s) based on:
              </p>
              <ul>
                <li>Obfuscated satellites that will not pass user details to the operators;</li>
                <li>Sensors that have opportunity tasking, which are shown by an opportunity icon;</li>
                <li>Sensors that have an available footprint, and</li>
                <li>The tasking tiers for each sensor from the drop-down menu.</li>
              </ul>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image30.jpg" alt="">
                <p class="text-centre"><i>Figure - 30</i></p>
              </div>
              
              <p>
                Users can select one or more sensors and customise each with additional options, such as imaging modes/product levels, resolution, minimum scene size, cloud cover, off-nadir angle, and the provided tasking tiers. Figure 31 highlights the ‘<span class="spl-bold">Total Selected Sensor</span>’ at the bottom-right of the screen, which shows the number of selected sensors.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image31.png" alt="">
                <p class="text-centre"><i>Figure - 31</i></p>
              </div>

              <p>
                After completing their selection, users can choose between automated tasking and opportunity tasking to submit the task.
              </p>
            </section>

            <section class="sub-container" id="value-added-data-products">
              <h3 >6.1 Value Added Data Products:</h3>
              <p>
                Value-added data products enhance the use of satellite data. Currently, there are three types of value-added products: (1) Super Resolution, (2) Digital models, and (3) Indices.
              </p>
            </section>

            <section class="sub-container" id="super-resolution">
              <h3 >6.1.1. Super Resolution</h3>
              <p>
                Super-resolution (SR) refers to techniques that enhance image resolution. After the user chooses the SR option, they continue to create the task, which includes SR costing <i> (Refer Figure - 32)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image32.png" alt="">
                <p class="text-centre"><i>Figure - 32</i></p>
              </div>

              <p>
                A satellite icon will appear for the SR request at the sensor level, as shown in Figure 33, when the task appears on the <span class="spl-bold">‘Recent’</span> tab of the dashboard screen after its creation.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image33.png" alt="">
                <p class="text-centre"><i>Figure - 33</i></p>
              </div>

            </section>

            <section class="sub-container" id="digital-model">
              <h3>6.1.2. Digital Models</h3>
              <p>
                Digital models (DMs) include the Digital Elevation Model (DEM) and represent Earth's bare-ground topographic surface, excluding trees, buildings, and other surface objects. DEM images comprise multiple scenes. The different available products are DTM (Digital Terrain Model) and DSM (Digital Surface Model).
              </p>
              <p>
                Digital models are available for stereo and tri-stereo sensor types. Users can select multiple digital
                models. Users add digital models to create a DM-included task. Users must select the relevant mode or
                product, as shown in Figure 34a, before choosing the elevation model(s) shown in Figure 34b.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image34a.png" alt="">
                <p class="text-centre"><i>Figure - 34a</i></p>
              </div>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image34b.png" alt="">
                <p class="text-centre"><i>Figure - 34b</i></p>
              </div>

              <p>
                The platform will display an icon at the sensor level to show that digital models are enabled <i>(Refer Figure - 35)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image35.png" alt="">
                <p class="text-centre"><i>Figure - 35</i></p>
              </div>
            </section>

            <section class="sub-container" id="indices">
              <h3>6.1.3. Indices</h3>
              <p>
                Index products use optical sensors. Indices are another value-added product, so the experience is like adding similar data products to sensors. Users select one or more indices, and the platform will price them accordingly <i>(Refer Figure - 36)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image36.png" alt="">
                <p class="text-centre"><i>Figure - 36</i></p>
              </div>

              <p>
                After making all the above selections of sensor(s), resolution, and optional value-added products, users have two options to choose from - (i) <span class="spl-bold">‘Automated tasking’</span> and (ii) <span class="spl-bold">‘Opportunity tasking’</span> <i>(Refer Figure - 37)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image37.png" alt="">
                <p class="text-centre"><i>Figure - 37</i></p>
              </div>

              <p>
                After selecting either (i) or (ii), users will see a pop-up that confirms the successful submission of the task  <i>(Refer Figure - 38)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image38.png" alt="">
                <p class="text-centre"><i>Figure - 38</i></p>
              </div>

              <p>
                If users choose (ii), the selected satellite operator(s) will provide a list of feasibility dates and times in the dashboard to choose from when clicking on the <span class="spl-bold">‘Capture Opportunities’</span> button.
              </p>

              <p>
                Next, users can check whether the selected sensor operators have approved or rejected the sensor(s) to proceed <i>(Refer Figure - 39)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image39.png" alt="">
                <p class="text-centre"><i>Figure - 39</i></p>
              </div>

              <p>
                Users can select from a list of feasibility options made available by the selected operator(s), along with the approval and click <span class="spl-bold">‘Save’</span> to proceed (Refer Figure - 40).
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image40.png" alt="">
                <p class="text-centre"><i>Figure - 40</i></p>
              </div>

              <p>
                On a successful save, the task is ready for ordering.
              </p>
            </section>

            <section class="sub-container" id="task-progress">
              <h3>7. Task Progress</h3>
              <p>All tasks go through the following status changes and appear on the dashboard.</p>
              <p>On submission, the platform triggers the following flows and sends the user an email notification about the status:</p>

              <p>Awaiting &#10141; Approved &#10141; Ordered &#10141; Delivering &#10141; Collected &#10141; Completed &#10141; Archived</p>
              <p>Awaiting &#10141; Approved &#10141; Ordered &#10141; Delivering &#10141; Collected &#10141; Completed &#10141; Archived &#10141; Restored</p>
              <p>Awaiting &#10141; Approved &#10141; Ordered &#10141; Failed</p>
              <p>Awaiting &#10141; Approved&#10141; Ordered &#10141; Cancelled</p>
              <p>Awaiting &#10141; Approved &#10141; Cancelled</p>
              <p>Awaiting &#10141; Rejected</p>
              <p>Awaiting &#10141; Cancelled</p>

              <p>Users can expand a task to view the individual sensors and their associated status, as shown above.</p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image41.png" alt="">
                <p class="text-centre"><i>Figure - 41</i></p>
              </div>

              <p>The numbered arrows in Figure 41 are explained below:</p>
              <ol>
                <li>Users can select one or more approved sensors and continue the order-creation process.</li>
                <li>Users can cancel any approved sensors from the task list.</li>
                <li>Users can add the selected sensors to the cart via the <span class="spl-bold">‘Add to Cart’</span> option. Items added to the cart will remain active until the operator-set time limit for placing orders, based on the TOI.
                </li>
                <li>
                  Alternatively, users can directly create an order via the <span class="spl-bold">‘Proceed to Pay’</span> option. Section 8(Payment) shows what happens next.
                </li>
                <li>Users can identify which dashboard tasks include information feeds by this status.</li>
                <li>Users preview the selected target area.</li>
                <li>Users can use this option to re-task a particular task. Re-Task is a feature that allows users to re-task  for a future date, keeping all preloaded details of the current task. Re-Task only works when all sensors have the same status (rejected, failed, completed, or cancelled).
                </li>
                <li>Users can filter the tasks listed on the dashboard.</li>
              </ol>

              <p>Users can rate and provide feedback for completed tasks <i>(Refer Figure - 42)</i>.</p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image42.png" alt="">
                <p class="text-centre"><i>Figure - 42</i></p>
              </div>
            </section>

            <section class="sub-container" id="cart-process">
              <h3>8. Cart process</h3>
              <p>
                This is where tasks added to the cart will appear. Users can either delete a particular task or complete the payment by clicking the <span class="spl-bold">‘Proceed to Pay’</span> button. After payment, the platform will remove the task from the cart screen <i>(Refer Figure - 43)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image43.png" alt="">
                <p class="text-centre"><i>Figure - 43</i></p>
              </div>
            </section>

            <section class="sub-container" id="payment">
              <h3>9. Payment</h3>
              <p>
                An <span class="spl-bold">‘Order number’</span> is auto-generated for the selected task on the payment screen <i>(Refer Figure - 44)</i>.
              </p>

              <ol>
                <li>Users must accept each selected sensor operator’s EULA before proceeding to pay.</li>
                <li>Users can choose between Platform Storage, My Storage, or both to store collections.</li>
                <li>Users can complete the payment by using any of the three payment options provided:</li>
                <ul>
                  <li>Pay Now — connects to online payment processors based on the user&#39;s choice to complete payment with a credit/ debit card.</li>

                  <li>Debit Account — a prepaid option via a deposit plan or top-ups, where a user’s credit balance is used to make a payment. Any top-up is done via payment processors, including bank transfers, and is available on the profile page.</li>

                  <li>Pay Later — users with approved credit terms may choose this option.</li>
                </ul>
              </ol>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image44.png" alt="">
                <p class="text-centre"><i>Figure - 44</i></p>
              </div>
            </section>

            <section class="sub-container" id="orders">
              <h3>10. Orders</h3>
              <p>
                Invoices, receipts, credit notes and credit memos associated with historical orders are available here for easy access <i>(Refer Figure - 45)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image45.png" alt="">
                <p class="text-centre"><i>Figure - 45</i></p>
              </div>

              <p>Users can perform the following activities:</p>
              <ul>
                <li>
                  View/download <span class="spl-bold">‘Invoice’</span> for payments made using the <span class="spl-bold">‘Pay Later’</span> method.
                </li>
                <li>
                  View/download <span class="spl-bold">‘Receipt’</span>, if payment is done by either <span class="spl-bold">‘Pay Now’</span> or <span class="spl-bold">‘Debit Account’</span> options.
                </li>
                <li>
                  View/download a <span class="spl-bold">‘Credit Note’</span> if a payment is credited to the account for failed and cancelled transactions, including net of any penalties.
                </li>
                <li>
                  View/download a <span class="spl-bold">‘Credit Memo’</span> issued to pay-later (invoice) users who are due a refund.
                </li>
                <li>
                  Generate an <span class="spl-bold">‘Order Report’</span> based on the user-inputted date range.
                </li>
                <li>
                  Export the report as a CSV file by clicking on the <span class="spl-bold">‘Export CSV’</span> button.
                </li>
              </ul>
            </section>

            <section class="sub-container" id="collections">
              <h3>11. Collections</h3>

              <p>
                All task data, along with the requested feeds, is available here, and users can select each task's data using the project name. The organisation of collections by projects and tasks is based on the projects and tasks created, and they automatically appear here when the collection starts. If the user’s projects have multiple tasks, then those tasks will show in a dropdown <i>(Refer Figure - 46)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image46.png" alt="">
                <p class="text-centre"><i>Figure - 46</i></p>
              </div>

              <p>The numbered arrows in Figure 46 are explained below:</p>
              <ol>
                <li>
                  A user can <span class="spl-bold">view</span> a single scene, multiple scenes, or the entire task.
                </li>
                <li>
                  <span class="spl-bold">Metadata icon</span> for each scene is also available in the scene tooltip.
                </li>
                <li>
                  The <span class="spl-bold">hourglass icon</span> if it’s gray in color then the data is yet to be populated; if blue, the data delivery is underway.
                </li>
                <li>
                  The exclamation mark <span class="spl-bold">‘!’ icon</span> represents the failure to deliver the data.
                </li>
                <li>
                  The <span class="spl-bold">downloaded icon</span> indicates the data has already been downloaded.
                </li>
                <li>
                  Users can also request a refund for each scene by selecting the <span class="spl-bold">‘$’ refund icon</span>. The icon is enabled only after the scenes are downloaded. Users can return an ordered feed from the collection page and have the cost of the feed refunded. Users must justify the refund in the pop-up that appears when they click the refund icon. Users should not use the feed once the refund is processed.
                </li>
                <li>
                  Users can download the images using the <span class="spl-bold">download icon</span>. The downloaded zipped file contains at least a thumbnail, a GeoTIFF, and metadata. If the download icon is gray in color, the data is yet to be available for download; if blue, then it is ready to download.
                </li>
              </ol>
              <p>
                Users can select data from different <span class="spl-bold">recurrence periods</span> and select multiple images to populate <i>(Refer Figure - 47)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image47.png" alt="">
                <p class="text-centre"><i>Figure - 47</i></p>
              </div>

              <p>
                After 15 days, the data will be <span class="spl-bold">Archived</span>. The <span class="spl-bold">archived icon</span> is displayed after the download icon at the sensor level. Users will no longer be able to view or download the image unless they request restoration by clicking the archived icon and submitting a request in the pop-up <i>(Refer Figure - 48)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image48.png" alt="">
                <p class="text-centre"><i>Figure - 48</i></p>
              </div>

              <p>
                Users can <span class="spl-bold">compare multiple images </span> on the same screen using split-window functionality <i>(Refer Figure - 49)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image49.png" alt="">
                <p class="text-centre"><i>Figure - 49</i></p>
              </div>

              <p>
                Users can create tasks directly from the collection screen by clicking the <span class="spl-bold">‘Collection Point Tasking’</span> button. Only point tasking is enabled, allowing users to right-click a coordinate of interest in the delivered tasked data <i>(Refer Figure - 50)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image50.png" alt="">
                <p class="text-centre"><i>Figure - 50</i></p>
              </div>

              <p>
                Users then specify a minimum set of requirements in the task creation pop-up (Figure 51), and the platform schedules the tasking based on satellite(s) availability per the requirement.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image51.png" alt="">
                <p class="text-centre"><i>Figure - 51</i></p>
              </div>

              <p>
                Users can <span class="spl-bold">annotate</span> the delivered data on the collection page. Annotations can be created, edited, and deleted. The annotation button is enabled with the scene selection <i>(Refer Figure - 52)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image52.png" alt="">
                <p class="text-centre"><i>Figure - 52</i></p>
              </div>

              <p>
                To add a new annotation, users right-click on the task data. A text area will appear, allowing them to enter a description and save it by clicking on the save icon <i>(Refer Figure - 53)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image53.png" alt="">
                <p class="text-centre"><i>Figure - 53</i></p>
              </div>

              <h4>AIS-specific use scenarios</h4>
              <p>
                When a vessel’s AIS is switched off, users can request a prediction of its possible locations. From the vessel’s last known location, users can request these future predictions, which are displayed along with the last known location.
              </p>
              <p>
                To view vessel predictions, select a vessel’s last known location on the map. A pop-up will appear prompting users to request predictions. Click <span class="spl-bold">‘Predicted’</span> and submit the request <i>(Refer Figure - 54)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image54.png" alt="">
                <p class="text-centre"><i>Figure - 54</i></p>
              </div>

              <p>
                This retrieves the vessel’s known predictions <i>(Refer Figure - 55)</i>. The number of predicted locations varies.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image55.png" alt="">
                <p class="text-centre"><i>Figure - 55</i></p>
              </div>

              <p>
                <span class="spl-bold">'Past Predictions'</span> of vessels on the collection page lists the live predictions that users have already viewed <i>(Refer Figure - 56)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image56.png" alt="">
                <p class="text-centre"><i>Figure - 56</i></p>
              </div>

              <p>
                Users can view a vessel’s historical positions by selecting the relevant scene or sensor checkbox and then clicking on the vessel of interest on the map. From the pop-up, users choose <span class="spl-bold">‘Historic’</span>, enter the required historical period for the trail in minutes, and submit the request  <i>(Refer Figures - 57a and 57b)</i>.
              </p>
              
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image57a.png" alt="">
                <p class="text-centre"><i>Figure - 57a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image57b.png" alt="">
                <p class="text-centre"><i>Figure - 57b</i></p>
              </div>


              <p>
                Revisiting prior refreshes is required to understand the steps taken to detect vessel(s) of interest. Each AIS feed refresh within the AOI triggers the saving of the location, which then becomes available for map display and download <i>(Refer Figure - 58)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image58.png" alt="">
                <p class="text-centre"><i>Figure - 58</i></p>
              </div>


            </section>

            <section class="sub-container" id="deposits">
              <h3>12. Deposits</h3>
              <p>
                Here, users can view and download the records of all the deposits made on the platform <i>(Refer Figure - 59)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image59.png" alt="">
                <p class="text-centre"><i>Figure - 59</i></p>
              </div>

              <p>
                Users can deposit funds via online payment processors or bank transfers, and the platform will generate corresponding receipts.
              </p>
            </section>

            <section class="sub-container" id="budgets">
              <h3>13. Budgets</h3>
              <p>
                Users can generate a budget for a proposed task that includes imaging, non-imaging, or both. This separation allows greater flexibility when defining user requirements. To generate a budget, users can select the Budget option from the left panel and enter the required inputs. A pop-up will appear with the budget generated as a range. It’s a range because multiple providers may satisfy the requirement. The platform will display the lowest and highest budgets as a range.
              </p>
              <p>
                Click on <span class="spl-bold">‘New’</span> in the budget section to create a new budget <i>(Refer Figures - 60a and 60b)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image60a.png" alt="">
                <p class="text-centre"><i>Figure - 60a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image60b.png" alt="">
                <p class="text-centre"><i>Figure - 60b</i></p>
              </div>

              <p>
                Once a budget is generated, users may proceed directly to task (Figures 61a and 61b) by providing additional information needed, such as project name, or they can save (Figure 61c) the budget for later reference or future tasking, provided the TOI has not expired.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image61a.png" alt="">
                <p class="text-centre"><i>Figure - 61a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image61b.png" alt="">
                <p class="text-centre"><i>Figure - 61b</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image61c.png" alt="">
                <p class="text-centre"><i>Figure - 61c</i></p>
              </div>

              <p>
                Now, the user clicks on the <span class="spl-bold">‘Submit’</span> option as represented in Figure 61d.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image61d.png" alt="">
                <p class="text-centre"><i>Figure - 61d</i></p>
              </div>

              <p>
                The budget record will then be listed on the Budgets page (similar to Deposits or Orders) <i>(Refer Figure - 62)</i> .
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image62.png" alt="">
                <p class="text-centre"><i>Figure - 62</i></p>
              </div>

              <p>
                When users choose to task a saved budget, they click on the three dots under Action (Figure 63a) and task straightaway after providing the project identification details (Figure 63b). The task request will be updated on the dashboard in real time for a new task, as discussed in Section 4.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image63a.png" alt="">
                <p class="text-centre"><i>Figure - 63a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image63b.png" alt="">
                <p class="text-centre"><i>Figure - 63b</i></p>
              </div>
            </section>

            <section class="sub-container" id="quotes">
              <h3>14. Quotes</h3>
              <p>
                When registering for the platform access, users can generate a quotation. The quotation is both emailed to users and displayed on the platform under the Quotes section. When the quotation option is selected, a pop-up appears prompting users to enter the amount. Quotations can also be generated on demand when topping up the account balance on the user’s profile page <i> (Refer Figures - 64a to 64c)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image64a.png" alt="">
                <p class="text-centre"><i>Figure - 64a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image64b.png" alt="">
                <p class="text-centre"><i>Figure - 64b</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image64c.png" alt="">
                <p class="text-centre"><i>Figure - 64c</i></p>
              </div>
            </section>

            <section class="sub-container" id="users">
              <h3>15. Users</h3>
              <p>
                A user management interface where individual users within an organisation are listed along with their details and permissions <i> (Refer Figure - 65)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image65.png" alt="">
                <p class="text-centre"><i>Figure - 65</i></p>
              </div>

              <p>
                Each row represents a user's details, including the areas where they are authorised to task and their assigned permissions. The record also includes an <span class="spl-bold">‘Edit’</span> option to change user details. The map icon indicates that the <span class="spl-bold">‘Allowed Tasking Areas’</span>  can be configured <i>(Refer Figure - 66)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image66.png" alt="">
                <p class="text-centre"><i>Figure - 66</i></p>
              </div>

              <p>
                The superuser can add a <span class="spl-bold"> ‘New’</span> user, efficiently manage user roles, permissions, and access within the platform   <i> (Refer Figure - 67)</i>.
              </p>

              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image67.png" alt="">
                <p class="text-centre"><i>Figure - 67</i></p> 
              </div>

              <div class="sub-content">
                <ul>
                  <li>
                    When the superuser adds a new user, they can assign a budget in the 
                    <span class="spl-bold">‘User Budget ($)’</span> field and the <span class="spl-bold">‘Organisational A/C Balance ($)’</span> will automatically show the remaining account balance <i>(Refer Figure - 68)</i>.


                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image68.png" alt="">
                      <p class="text-centre"><i>Figure - 68</i></p> 
                    </div>
                  </li>

                  <li>
                    <span class="spl-bold">Allowed Tasking Areas: </span>
                     Uploading a map file within which a user is permitted to create tasks. The superuser can assign one or more polygons by uploading them, as shown in Figure 69, when creating or editing a user record. No assignment means a user can task globally.

                      <div class="attachement-img">
                        <img src="../../../../../assets/how-it-works/image69.png" alt="">
                        <p class="text-centre"><i>Figure - 69</i></p> 
                      </div>
                  </li>
                  <li>
                    <span class="spl-bold">User Permissions: </span>
                    Displays the user’s specific roles. Available permissions include <span class="spl-bold">‘Create or Cancel Tasks/Feeds’, ‘Approve or Reject Tasks/Feeds’, ‘Order Tasks/Feeds’, ‘Cancel Ordered Tasks/Feeds’, ‘Receive Data’, ‘Collection Point Tasking’, </span> and <span class="spl-bold">‘Tip-and-Cue workflow’</span>. When editing a user record, a superuser can modify the user’s permissions <i>(Refer Figure - 70)</i>.

                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image70.png" alt="">
                      <p class="text-centre"><i>Figure - 70</i></p> 
                    </div>
                  </li>
                  <li>
                    <span class="spl-bold">Grant Access: </span>
                    A superuser can also use the option <span class="spl-bold">‘Delegate My Tasks’</span> to delegate their tasks to select users and give deposit access to them by using the <span class="spl-bold">‘User Can Deposit’</span> option <i>(Refer Figure - 71)</i>.


                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image71.png" alt="">
                      <p class="text-centre"><i>Figure - 71</i></p>
                    </div>
                  </li>
                  <li>
                    <span class="spl-bold">Enable/Disable:</span>
                     The superuser can enable or disable a user's ability to perform platform activities while still allowing them to log in. This helps organisations temporarily suspend users without fully revoking access, and it can be done via the <span class="spl-bold">‘Enable/Disable’</span> checkbox on the user management screen, provided the user has no ongoing tasks <i>(Refer Figure - 72)</i>.


                    <div class="attachement-img">
                      <img src="../../../../../assets/how-it-works/image72.png" alt="">
                      <p class="text-centre"><i>Figure - 72</i></p>
                    </div>
                  </li>
                </ul>
              </div>
            </section>

            <section class="sub-container" id="sub-accounts">
              <h3>16. Sub Accounts</h3>
              <p>
                When Organisations require Sub Accounts under a single master Account, <span class="spl-bold">Sub Accounts</span> option can be used to create one. Users can click on <span class="spl-bold">‘New’</span> and furnish details such as Full name, Display name, Email, Total Budget and Balance <i>(Refer Figure - 73a and 73b)</i>. Once the details are filled in, click on ‘Save’ to create the sub account.
              </p>


              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image73a.png" alt="">
                <p class="text-centre"><i>Figure - 73a</i></p>
              </div>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image73b.png" alt="">
                <p class="text-centre"><i>Figure - 73b</i></p>
              </div>
            </section>

            <section class="sub-container" id="additional-information">
              <h3>17. Additional Information</h3>
              <p>The other available options on the platform are listed below <i>(Refer Figure - 74)</i>.</p>
              <div class="sub-content">
                <ul>
                  <li>
                    <span class="spl-bold">Home: </span>Allows users to go to the ‘Dashboard’ page.
                  </li>
                  <li>
                    <span class="spl-bold">How It Works: </span>Takes users to the product guide.
                  </li>
                  <li>
                    <span class="spl-bold">What’s New: </span>Lists latest platform features and sensors.
                  </li>
                  <li>
                    <span class="spl-bold">Privacy Policy: </span>Gives in detail the privacy policy that applies to individuals and organisations who use EARTHEYE’s services.
                  </li>
                  <li>
                    <span class="spl-bold">Acceptable Use Policy: </span>
                     This ensures intended, efficient, lawful, and ethical use of the Services, Platform and the hosting infrastructure for the benefit of all users.

                      <div class="attachement-img">
                        <img src="../../../../../assets/how-it-works/image74.png" alt="">
                        <p class="text-centre"><i>Figure - 74</i></p>
                      </div>
                  </li>
                </ul>
              </div>
            </section>

            <section class="sub-container" id="acronyms">
              <h3>18. Acronyms</h3>

              <table border="1" cellpadding="8" cellspacing="0">
                <tr>
                <th>Sl. No.</th><th>Acronym</th><th>Full Form</th>
                </tr>

                <tr>
                <td>1</td><td>AIS</td><td>Automatic Identification System</td>
                </tr>

                <tr>
                <td>2</td><td>AOI</td><td>Area of Interest</td>
                </tr>

                <tr>
                <td>3</td><td>EULA</td><td>End User License Agreement</td>
                </tr>

                <tr>
                <td>4</td><td>GHG</td><td>Greenhouse Gas</td>
                </tr>

                <tr>
                <td>5</td><td>HSI</td><td>Hyperspectral Imaging</td>
                </tr>

                <tr>
                <td>6</td><td>InSAR</td><td>Interferometry SAR</td>
                </tr>

                <tr>
                <td>7</td><td>KYC</td><td>Know Your Customer</td>
                </tr>

                <tr>
                <td>8</td><td>MSI</td><td>Multispectral Imaging</td>
                </tr>

                <tr>
                <td>9</td><td>NDVI</td><td>Normalised Difference Vegetation Index</td>
                </tr>

                <tr>
                <td>10</td><td>NDRE</td><td>Normalised Difference Red Edge</td>
                </tr>

                <tr>
                <td>11</td><td>NCCI</td><td>Normalised Canopy Chlorophyll Index</td>
                </tr>

                <tr>
                <td>12</td><td>ONA</td><td>Off Nadir Angle</td>
                </tr>

                <tr>
                <td>13</td><td>PAN</td><td>Panchromatic</td>
                </tr>

                <tr>
                <td>14</td><td>POI</td><td>Point of Interest</td>
                </tr>

                <tr>
                <td>15</td><td>RF</td><td>Radio Frequency</td>
                </tr>

                <tr>
                <td>16</td><td>SAR</td><td>Synthetic Aperture Radar</td>
                </tr>

                <tr>
                <td>17</td><td>TIR</td><td>Thermal Infrared</td>
                </tr>

                <tr>
                <td>18</td><td>TLE</td><td>Two-line Element Set</td>
                </tr>

                <tr>
                <td>19</td><td>TOI</td><td>Time of Interest</td>
                </tr>

                <tr>
                <td>20</td><td>UTC</td><td>Coordinated Universal Time</td>
                </tr>

                <tr>
                <td>21</td><td>VADP</td><td>Value Added Data Product</td>
                </tr>

                </table>
            </section>

            <section class="sub-container" id="glossary">
              <h3>19. Glossary</h3>
              <table>
                <tr>
                <th>Sl. No.</th>
                <th>Item Name</th>
                <th>Description</th>
                </tr>

                <tr>
                <td>1</td>
                <td>Allowed Tasking Area</td>
                <td>An area that a user is allowed to task.</td>
                </tr>

                <tr>
                <td>2</td>
                <td>Cloud Cover</td>
                <td>The percentage of cloud cover acceptable in a collection.</td>
                </tr>

                <tr>
                <td>3</td>
                <td>End Date (UTC)</td>
                <td>The TOI end date in UTC.</td>
                </tr>

                <tr>
                <td>4</td>
                <td>Feeds</td>
                <td>The automated information extraction services.</td>
                </tr>

                <tr>
                <td>5</td>
                <td>First Capture</td>
                <td>The first capture opportunity within the TOI as determined by the chosen sensor(s).</td>
                </tr>

                <tr>
                <td>6</td>
                <td>Grazing Angle</td>
                <td>The angle between the sensor beam’s contact angle and the Earth’s surface.</td>
                </tr>

                <tr>
                <td>7</td>
                <td>Hold Back</td>
                <td>The time a satellite operator takes to add a tasked image to the archive for access by other customers.</td>
                </tr>

                <tr>
                <td>8</td>
                <td>Intent</td>
                <td>Declaration of how the tasked data would be used.</td>
                </tr>

                <tr>
                <td>9</td>
                <td>Last Capture</td>
                <td>The last capture opportunity within the TOI as determined by the chosen sensor(s).</td>
                </tr>

                <tr>
                <td>10</td>
                <td>Look Angle</td>
                <td>The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).</td>
                </tr>

                <tr>
                <td>11</td>
                <td>Looks</td>
                <td>The number of times an observation is repeatedly made by a SAR satellite at the location of interest.</td>
                </tr>

                <tr>
                <td>12</td>
                <td>Minimum Collection</td>
                <td>The minimum payable area, regardless of the requested task area.</td>
                </tr>

                <tr>
                <td>13</td>
                <td>Model</td>
                <td>The sensor imaging mode of a satellite.</td>
                </tr>

                <tr>
                <td>14</td>
                <td>Night Imagery</td>
                <td>Satellite imagery collected at night, either by SAR or MSI sensors.</td>
                </tr>

                <tr>
                <td>15</td>
                <td>Obfuscated</td>
                <td>The information is hidden behind a randomised or specified label.</td>
                </tr>

                <tr>
                <td>16</td>
                <td>Observation</td>
                <td>In a tip-and-cue workflow, an observation defines when the cued sensors are tasked.</td>
                </tr>

                <tr>
                <td>17</td>
                <td>Off Nadir Angle</td>
                <td>The degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.</td>
                </tr>

                <tr>
                <td>18</td>
                <td>Opportunities</td>
                <td>The possible captures available from a satellite or constellation within a TOI.</td>
                </tr>

                <tr>
                <td>19</td>
                <td>Order Cost</td>
                <td>The total order cost includes one or more sensors and any attached feeds for the task.</td>
                </tr>

                <tr>
                <td>20</td>
                <td>Previous Actor</td>
                <td>The user who performed the last action in the permission-based workflow.</td>
                </tr>

                <tr>
                <td>21</td>
                <td>Product</td>
                <td>The requested image product level.</td>
                </tr>

                <tr>
                <td>22</td>
                <td>Purpose</td>
                <td>Association of a task with the use of the platform in different industry contexts.</td>
                </tr>

                <tr>
                <td>23</td>
                <td>Reaction Time</td>
                <td>The latest time to schedule a task request based on the TOI start.</td>
                </tr>

                <tr>
                <td>24</td>
                <td>Repeat Frequency</td>
                <td>Determines the number of collections made within the TOI.</td>
                </tr>

                <tr>
                <td>25</td>
                <td>Resolution</td>
                <td>The resolution per pixel of an image.</td>
                </tr>

                <tr>
                <td>26</td>
                <td>Response Time</td>
                <td>Time from collection by satellite(s) to delivery.</td>
                </tr>

                <tr>
                <td>27</td>
                <td>Rules</td>
                <td>In tip-and-cue workflows, rules define when the cued sensors are tasked.</td>
                </tr>

                <tr>
                <td>28</td>
                <td>Sensor Cost</td>
                <td>The individual cost of a sensor for the task requested/ordered.</td>
                </tr>

                <tr>
                <td>29</td>
                <td>Start Date (UTC)</td>
                <td>The TOI start date in UTC.</td>
                </tr>

                <tr>
                <td>30</td>
                <td>Status</td>
                <td>The traffic lighting system indicates the progress of a task.</td>
                </tr>

                <tr>
                <td>31</td>
                <td>Submission Date (UTC)</td>
                <td>The task creation date in UTC.</td>
                </tr>

                <tr>
                <td>32</td>
                <td>Super User</td>
                <td>The primary or admin-equivalent user of the platform.</td>
                </tr>

                <tr>
                <td>33</td>
                <td>Task Strategy</td>
                <td>The tasking workflow is to be used for a particular task.</td>
                </tr>

                <tr>
                <td>34</td>
                <td>Tasked Area</td>
                <td>The area defined by AOI drawing/upload or POI depending on sensor scene size.</td>
                </tr>

                <tr>
                <td>35</td>
                <td>Tasking Tier</td>
                <td>The overall latency at which tasking is carried out.</td>
                </tr>

                <tr>
                <td>36</td>
                <td>Tip-and-Cue</td>
                <td>An automated workflow where two sensors are used in sequence separated by rules or observations.</td>
                </tr>

                <tr>
                <td>37</td>
                <td>User</td>
                <td>A platform user whose access is controlled by a superuser.</td>
                </tr>

                <tr>
                <td>38</td>
                <td>User Permissions</td>
                <td>A set of task-related permissions granted to a user by a superuser.</td>
                </tr>

                <tr>
                <td>39</td>
                <td>Value Added Data Products</td>
                <td>A value addition to an image product.</td>
                </tr>

                <tr>
                <td>40</td>
                <td>NCCI</td>
                <td>Precision nutrient intelligence targeting chlorophyll content for nitrogen management.</td>
                </tr>

                <tr>
                <td>41</td>
                <td>NDRE</td>
                <td>Detects early stress and chlorophyll variability in dense canopies.</td>
                </tr>

                <tr>
                <td>42</td>
                <td>NDVI</td>
                <td>Measures canopy vigour and photosynthetic activity using near-infrared and red-light absorption.</td>
                </tr>

                </table>
            </section>

             <section class="sub-container" id="conclusion">
              <h3>20. Conclusion </h3>
              <p>
                This concludes the walk-through, familiarising users with the product and its intended use scenarios. This guide is by no means exhaustive. We encourage you to email support@eartheye.space or provide your comments or raise queries via <span class="spl-bold">‘Contact Us’</span> <i>(Refer Figure - 75)</i>.
              </p>
              <div class="attachement-img">
                <img src="../../../../../assets/how-it-works/image75.png" alt="">
                <p class="text-centre"><i>Figure - 75</i></p>
              </div>

            </section>
        </div>
      
    </div>
    
    <!-- <iframe src="../../../../../assets/files/Eartheye_doc.pdf#toolbar=0&navpanes=0&scrollbar=0"
            width="100%" height="77%"> 
    </iframe> -->
  </div>
</div>
</div>